/**
 * 公共状态
 */

// 设置用户信息
export const SET_USER = 'SET_USER'



// WEBPACK FOOTER //
// ./src/store/types.js